import {TranslationKey} from '@enums'
import {Grid} from '@mui/material'

import React from 'react'

import {onImageError, renderFormField} from 'common'

import {ComposedComponents, UIKit} from '@components'

import {ImageWrapper, imageStyle} from './style'
import {useUserFormModel} from './user-form-model'

/**
 * User Form page
 */
export function UserFormPage() {
  const {
    userGeneralFormFields,
    userAdditionalFormFields,
    userRoleFormField,
    imageUrl,
    isPartnerAdminUser,
    t,
    userAdditionalFormFieldsForPartnerUser,
    handleDrop,
    onSubmit,
    onDiscard,
  } = useUserFormModel()

  return (
    <>
      <UIKit.BackgroundCard title={t(TranslationKey['General information'])}>
        <Grid container spacing={2}>
          <Grid item sm={3}>
            <UIKit.ImageDropzone
              image={
                <ImageWrapper>
                  <img src={imageUrl || ''} alt="User image" style={imageStyle} onError={onImageError} />
                </ImageWrapper>
              }
              handleDrop={handleDrop}
            />
          </Grid>
          <Grid item sm={9}>
            <Grid container spacing={2}>
              {userGeneralFormFields.map((item, index) => (
                <Grid sm={6} item key={`user-form-general-form-field-${index}`}>
                  {renderFormField(item)}
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </UIKit.BackgroundCard>

      <UIKit.BackgroundCard>
        <Grid container spacing={2}>
          <Grid item sm={3}>
            {renderFormField(userRoleFormField)}
          </Grid>
          <Grid item sm={3}>
            <Grid container spacing={2}>
              {userAdditionalFormFields.map((item, index) => (
                <Grid sm={12} item key={`user-form-additional-form-field-${index}`}>
                  {renderFormField(item)}
                </Grid>
              ))}
            </Grid>
          </Grid>
          <Grid item sm={6}>
            {isPartnerAdminUser && renderFormField(userAdditionalFormFieldsForPartnerUser)}
          </Grid>
        </Grid>
      </UIKit.BackgroundCard>
      <ComposedComponents.FormButtons
        leftButton={{label: t(TranslationKey.Discard), onClick: onDiscard}}
        rightButton={{label: t(TranslationKey.Save), onClick: onSubmit}}
      />
    </>
  )
}
